import { object, string } from 'yup'
import dayjs from 'dayjs'

export const CommonFieldsValidateSchema = object().shape({
	dpositionCode: string().required({ key: 'required' }).nullable(),
	establishedPostKz: string().required({ key: 'required' }).nullable(),
	establishedPostRu: string().required({ key: 'required' }).nullable(),
	serviceDescriptionKz: string().required({ key: 'required' }).nullable(),
	serviceDescriptionRu: string().required({ key: 'required' }).nullable(),
	totalPaymentAmount: string().required({ key: 'required' }).nullable(),
	dpaymentScheduleCode: string().required({ key: 'required' }).nullable(),
	dremoteWorkCode: string()
		.nullable()
		.test(
			'dcountryCode-check',
			{ key: 'required' },
			function(value) {
				const { dcountryCode } = this.parent
				if (value && dcountryCode) {
					return Number(dcountryCode) === 398
				} else {
					return true
				}
			},
		),
	dcountryCode: string()
		.when('dremoteWorkCode', {
			is: (dremoteWorkCode) => Number(dremoteWorkCode) === 1,
			then: string().nullable(),
			otherwise: string().required({ key: 'required' }).nullable(),
		}).nullable(),
	ddistrictCode: string().when('dcountryCode', {
		is: (dcountryCode) => Number(dcountryCode) === 398,
		then: string().required({ key: 'required' }).nullable(),
	}).nullable(),
	dregionCode: string().when('dcountryCode', {
		is: (dcountryCode) => Number(dcountryCode) === 398,
		then: string().required({ key: 'required' }).nullable(),
	}).nullable(),
	dlocalityCode: string()
		.nullable()
		.when(['dcountryCode', 'dremoteWorkCode'], {
			is: (dcountryCode, dremoteWorkCode) => Number(dcountryCode) === 398 || Number(dremoteWorkCode) === 1,
			then: string()
				.nullable()
				.test(
					'undefined-or-non-empty-string',
					{ key: 'required' },
					(value) =>
						value === undefined ||
						(typeof value === 'string' && value.trim().length > 0)
				),
			otherwise: string()
				.nullable()
				.test(
					'not-null',
					{ key: 'required' },
					(value) => value !== null
				),
		}),
	workPlace: string().when(['dremoteWorkCode', 'dcountryCode'], {
		is: (dremoteWorkCode, dcountryCode) => Number(dremoteWorkCode) === 1 && !dcountryCode,
		then: string().nullable(),
		otherwise: string().required({ key: 'required' }).nullable(),
	}).nullable(),
})